import { CSSProperties, ReactNode } from 'react'
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful'

import CommonColorPickerStyles from 'common/ColorPicker/ColorPicker.module.scss'
import Styles from './ColorPicker.module.scss'

import { Pressable } from '@react-aria/interactions'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { EditDrawer } from './EditDrawer/EditDrawer'

const DEFAULT_COLORS = [
  CommonColorPickerStyles.navy30,
  CommonColorPickerStyles.blue30,
  CommonColorPickerStyles.green30,
  CommonColorPickerStyles.gold30,
  CommonColorPickerStyles.orange30,
  CommonColorPickerStyles.red30,
  CommonColorPickerStyles.pink30,
  CommonColorPickerStyles.violet30,
  CommonColorPickerStyles.gray30,
]

interface Props {
  ariaLabel?: string
  color: string | null
  colors?: string[]
  children: ReactNode
  disabled?: boolean
  onChange: (color: string | null) => void
  onClose: () => void
  previewColors?: string[]
  setPreviewColors?: (colors: string[]) => void
}

export const ColorPicker = ({
  ariaLabel,
  children,
  color,
  colors = DEFAULT_COLORS,
  disabled,
  onChange,
  onClose,
  previewColors,
  setPreviewColors,
}: Props) => {
  const { drawersStore } = useRootStore()

  const openDrawer = () => {
    drawersStore.openDrawer(EditDrawer, { onChange, color, previewColors, setPreviewColors })
  }

  return (
    <>
      <ResponsiveDesign.Desktop>
        <DropdownTrigger popoverClassName={CommonColorPickerStyles.popover} onClose={onClose}>
          <Pressable>
            <button aria-label={ariaLabel} disabled={disabled} type="button">
              {children}
            </button>
          </Pressable>
          {() => (
            <div className={CommonColorPickerStyles.picker}>
              <HexColorInput
                color={color || undefined}
                onChange={onChange}
                onBlur={() => onChange(color)}
                className={Styles.input}
              />
              <div className={Styles.divider} />
              <HexAlphaColorPicker color={color || undefined} onChange={onChange} />
              <div className={CommonColorPickerStyles.swatches}>
                {colors.map((color) => (
                  <button
                    key={color}
                    className={CommonColorPickerStyles.swatch}
                    style={{ '--swatch-color': color } as CSSProperties}
                    type="button"
                    onClick={() => onChange(color)}
                  />
                ))}
              </div>
            </div>
          )}
        </DropdownTrigger>
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <Pressable onPress={openDrawer}>
          <button aria-label={ariaLabel} disabled={disabled} type="button">
            {children}
          </button>
        </Pressable>
      </ResponsiveDesign.Mobile>
    </>
  )
}
